"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyUserLibraryEntities = void 0;
exports.userLibraryEntitiesSetMock = userLibraryEntitiesSetMock;
exports.userLibraryEntities = userLibraryEntities;
exports.useQueryUserLibraryEntities = useQueryUserLibraryEntities;
exports.useInfiniteQueryUserLibraryEntities = useInfiniteQueryUserLibraryEntities;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function userLibraryEntitiesSetMock(mock) {
    setMock = mock;
}
async function userLibraryEntities(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v2/user-library/entities`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.groupBy = params.groupBy;
    queryParams.sortBy = params.sortBy;
    queryParams.activePulse = params.activePulse;
    queryParams.includedEntities = params.includedEntities;
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.membershipType = params.membershipType;
    queryParams.doEnableScaling = params.doEnableScaling;
    queryParams.doEnableChallengeStore = params.doEnableChallengeStore;
    queryParams.page = params.page;
    queryParams.perPage = params.perPage;
    queryParams.calorieRanges = params.calorieRanges;
    queryParams.categories = params.categories;
    queryParams.continents = params.continents;
    queryParams.difficultyScores = params.difficultyScores;
    queryParams.distanceRanges = params.distanceRanges;
    queryParams.locationTypes = params.locationTypes;
    queryParams.requiredEquipment = params.requiredEquipment;
    queryParams.targetAreas = params.targetAreas;
    queryParams.timeRanges = params.timeRanges;
    queryParams.trainerIds = params.trainerIds;
    queryParams.freeOnly = params.freeOnly;
    queryParams.hasCompleted = params.hasCompleted;
    queryParams.workoutFilters = params.workoutFilters;
    queryParams.languages = params.languages;
    queryParams.trim = params.trim;
    queryParams.returnFields = params.returnFields;
    queryParams.query = params.query;
    queryParams.modality = params.modality;
    queryParams.overrides = params.overrides;
    queryParams.overridesOnly = params.overridesOnly;
    if (params.etag !== undefined) {
        headers.etag = params.etag;
    }
    if (params['If-None-Match'] !== undefined) {
        headers['If-None-Match'] = params['If-None-Match'];
    }
    if (params['X-Llama-Namespaces'] !== undefined) {
        headers['X-Llama-Namespaces'] = params['X-Llama-Namespaces'];
    }
    if (params['X-Llama-Log-Level'] !== undefined) {
        headers['X-Llama-Log-Level'] = params['X-Llama-Log-Level'];
    }
    if (params['Cache-Control'] !== undefined) {
        headers['Cache-Control'] = params['Cache-Control'];
    }
    if (params.Accept !== undefined) {
        headers.Accept = params.Accept;
    }
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyUserLibraryEntities = 'wolf-athenaeum-service:userLibraryEntities:get';
function useQueryUserLibraryEntities(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUserLibraryEntities, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryUserLibraryEntities(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUserLibraryEntities, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = userLibraryEntities(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=user-library-entities.js.map